import {matthew, mark, luke, john, acts, romans, cor1, cor2, galatians, ephesians, philippians, colossians, thess1, thess2, tim1, tim2, titus, philemon, hebrews, james, pet1, pet2, john1, john2, john3, jude, revelation} from './bible/nt-books.imba'
let bible = 
	matthew+' '+
	mark+' '+
	luke+' '+
	john+' '+
	acts+' '+
	romans+' '+
	cor1+' '+
	cor2+' '+
	galatians+' '+
	ephesians+' '+
	philippians+' '+
	colossians+' '+
	thess1+' '+
	thess2+' '+
	tim1+' '+
	tim2+' '+
	titus+' '+
	philemon+' '+
	hebrews+' '+
	james+' '+
	pet1+' '+
	pet2+' '+
	john1+' '+
	john2+' '+
	john3+' '+
	jude+' '+
	revelation+' '
class GenerateFrequencyList
	def constructor input_string
		# console.log input_string
		let res = sortByFrequency!
			countFrequency!
				makeArray(input_string)
		return res
	def makeArray input_string
		let res = input_string.split(' ')
		return res

	def countFrequency input_array
		const map = {}
		for item in input_array
			if map[item]
				map[item]++
			else
				map[item] = 1
		return map
	def sortByFrequency input_object
		let res = []
		let objects = []
		for own key,val of input_object
			objects.push {word: key, count: val}
		let sorted = objects.sort(do(a,b) parseFloat(b.count) - parseFloat(a.count))
		for item, i in sorted
			item.rank = i+1
			res.push item
		return res

let test = new GenerateFrequencyList bible

# TODO: Make frequency list from array.